module.exports = __webpack_public_path__ + "static/img/5.d565551.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/5.png
// module id = G7Ez
// module chunks = 0